import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconProductExport: React.FC<IconProps> = ({
  size = 15,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 27 27"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M8.30566 8.672C8.6282 8.51108 9.04791 8.64486 9.20996 8.96764C9.37122 9.29084 9.23733 9.71061 8.91455 9.87266C7.64498 10.4947 6.39897 11.1164 5.01016 11.7578L8.42139 13.522H8.41992L13.3278 15.9445L18.2611 13.5166L21.7871 11.7346L17.7766 9.921C17.449 9.76743 17.3016 9.35189 17.4551 9.02441C17.6088 8.69772 18.0244 8.55029 18.3516 8.70386L23.6108 11.1176C23.8741 11.2348 24.0112 11.5133 24.0113 11.8113V21.0351C24.0111 21.5839 23.6547 22.0686 23.1422 22.2927L13.5904 26.7072L13.3267 26.8313L13.0621 26.7072L3.55371 22.2927C3.04647 22.0686 2.69028 21.5882 2.6875 21.0387L2.6875 11.8151C2.68774 11.4615 2.85703 11.1355 3.14014 11.0597L4.50098 10.4584C5.79621 9.83447 7.09551 9.26058 8.30566 8.672ZM18.8535 14.7297L18.8398 14.7366L13.9882 17.0822V25.0263L22.6117 21.1952C22.6777 21.1686 22.7246 21.1021 22.7266 21.0351V12.7406L18.8535 14.7297ZM3.87891 21.0387C3.87909 21.1052 3.91758 21.1664 3.98145 21.1952L12.6016 25.0229V17.055L7.81372 14.7366L7.80469 14.7316L3.87891 12.7756L3.87891 21.0387ZM13.7886 1.36536L19.5234 6.73496C20.0197 7.20552 19.6649 8.13711 18.9844 8.13711H16.6055V11.6228C16.6049 11.9515 16.3398 12.2154 16.0111 12.2159C15.6819 12.2159 15.418 11.9521 15.4168 11.6228V6.77527H17.4844L13.3022 2.7739L8.85139 6.77527H11.3855V11.6228C11.3843 11.9521 11.1204 12.2159 10.7912 12.2159C10.4625 12.2153 10.199 11.9518 10.1978 11.6228V8.13711H7.51416C6.82207 8.13652 6.47149 7.19687 6.98438 6.73402L12.8684 1.35544L13.2773 0.933594L13.7886 1.36536Z" fill="currentColor"/>
  </svg>
);

export default IconProductExport;
